import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { promoSchema } from './schema'

function PromoModal({ isOpen, onClose, promoData, mode, onSubmit }) {
    const [loading, setLoading] = useState(false)
    const [submitError, setSubmitError] = useState(null)

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        defaultValues: promoData || {},
        resolver: yupResolver(promoSchema)
    })

    useEffect(() => {
        if (promoData) {
            reset(promoData)
        }
    }, [promoData, reset])

    const handleFormSubmit = async (data) => {
        setSubmitError(null)
        setLoading(true)
        try {
            await onSubmit(data)
            setLoading(false)
        } catch (error) {
            setSubmitError(error || 'Something went wrong')
            setLoading(false)
        }
    }

    if (!isOpen) return null

    return (
        <>
            <div className="modal-backdrop show"></div>
            <div className="modal d-block show" tabIndex="-1" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {mode === 'update' ? 'Update Promo' : 'Add Promo'}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                disabled={loading}
                            ></button>
                        </div>
                        <div className="modal-body">
                            {submitError && (
                                <div className="alert alert-danger">{submitError}</div>
                            )}

                            <form onSubmit={handleSubmit(handleFormSubmit)}>
                                <div className="mb-3">
                                    <label className="form-label">Promo Code:</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                                        {...register('code')}
                                        disabled={mode === 'update' || loading}
                                    />
                                    {errors.code && (
                                        <div className="invalid-feedback">{errors.code.message}</div>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Expiration Date:</label>
                                    <input
                                        type="date"
                                        className={`form-control ${errors.expirationDate ? 'is-invalid' : ''}`}
                                        {...register('expirationDate')}
                                        disabled={loading}
                                    />
                                    {errors.expirationDate && (
                                        <div className="invalid-feedback">{errors.expirationDate.message}</div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Redeem Limit:</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className={`form-control ${errors.redeemLimit ? 'is-invalid' : ''}`}
                                        {...register('redeemLimit')}
                                        disabled={loading}
                                    />
                                    {errors.redeemLimit && (
                                        <div className="invalid-feedback">{errors.redeemLimit.message}</div>
                                    )}
                                </div>
                                {mode === 'update' && (
                                    <div className="mb-3">
                                        <label className="form-label d-block">Active Status</label>
                                        <div className="form-check form-switch ps-0">
                                            <input
                                                type="checkbox"
                                                className="form-check-input ms-0"
                                                id="isActive"
                                                {...register('isActive')}
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={onClose}
                                        disabled={loading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading
                                            ? (mode === 'update' ? 'Updating...' : 'Adding...')
                                            : (mode === 'update' ? 'Update' : 'Add')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PromoModal
